// export var DEBUG_CONFIG = {
// 	DEBUG_NEW_SCHEDA_PRATICA: true,
// 	DEBUG_APP_SCHEDA_PRATICA: true,
// 	DEBUG_SCHEDA_PRATICA_FORM: true,
// 	DEBUG_SEZIONI: true,
// 	DEBUG_ALLEGATI: false,
// 	DEBUG_UPLOADER_ALLEGATI: false,
// 	DEBUG_ESITI: true,
// 	DEBUG_SCHEDA_PRATICA_MENU: true,
// }

export var DEBUG_CONFIG = {
	DEBUG_NEW_SCHEDA_PRATICA: false,
	DEBUG_APP_SCHEDA_PRATICA: false,
	DEBUG_SCHEDA_PRATICA_FORM: false,
	DEBUG_SEZIONI: false,
	DEBUG_ALLEGATI: false,
	DEBUG_UPLOADER_ALLEGATI: false,
	DEBUG_ESITI: false,
	DEBUG_SCHEDA_PRATICA_MENU: false,
	ELENCO_PRATICHE_UTENTE: false,
	DEBUG_DOWNLOAD: false,
}